import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function createCommissionFromDeal(dealId, agencyId, payload = {}) {
  return fundingHqFetch(
    `/deals/${encodeURIComponent(dealId)}/commission?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function fetchFundingCommissions({
  agencyId,
  status,
  payoutStatus,
  clawbackRisk,
  assignedUserId,
  payoutDueFrom,
  payoutDueTo,
  search,
  limit = 200,
} = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (status) params.set('status', status);
  if (payoutStatus) params.set('payout_status', payoutStatus);
  if (clawbackRisk) params.set('clawback_risk', clawbackRisk);
  if (assignedUserId) params.set('assigned_user_id', assignedUserId);
  if (payoutDueFrom) params.set('payout_due_from', payoutDueFrom);
  if (payoutDueTo) params.set('payout_due_to', payoutDueTo);
  if (search) params.set('search', search);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  const data = await fundingHqFetch(`/commissions${query ? `?${query}` : ''}`);
  return {
    commissions: data.commissions ?? [],
    total: data.total ?? (data.commissions?.length ?? 0),
  };
}

export async function fetchClientFundingCommissions(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/commissions?${agencyQuery(agencyId)}`,
  );
  return {
    commissions: data.commissions ?? [],
    total: data.total ?? (data.commissions?.length ?? 0),
  };
}

export async function fetchDealFundingCommissions(dealId, agencyId) {
  const data = await fundingHqFetch(
    `/deals/${encodeURIComponent(dealId)}/commissions?${agencyQuery(agencyId)}`,
  );
  return {
    commissions: data.commissions ?? [],
    total: data.total ?? (data.commissions?.length ?? 0),
  };
}

export async function fetchFundingCommission(commissionId, agencyId) {
  return fundingHqFetch(
    `/commissions/${encodeURIComponent(commissionId)}?${agencyQuery(agencyId)}`,
  );
}

export async function updateFundingCommission(commissionId, agencyId, payload) {
  return fundingHqFetch(
    `/commissions/${encodeURIComponent(commissionId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteFundingCommission(commissionId, agencyId) {
  return fundingHqFetch(
    `/commissions/${encodeURIComponent(commissionId)}?${agencyQuery(agencyId)}`,
    { method: 'DELETE' },
  );
}
